import PropTypes from 'prop-types';
import OwnerFields from '../../GeneralInfo/OwnerFields';
import ScientificSecretaryFields from '../../GeneralInfo/ScientificSecretaryFields';
import MainParticipantFields from '../../GeneralInfo/MainParticipantFields';
import ParticipantFields from '../../GeneralInfo/ParticipantFields';
import DomesticExpertFields from '../../GeneralInfo/DomesticExpertFields';
import InternationalExpertFields from '../../GeneralInfo/InternationalExpertFields';
import TechnicianFields from '../../GeneralInfo/TechnicianFields';

export default function ViewHistoricalPersonnelAdjustmentItem({
  members,
  isLoading,
  formatIndex,
  formatFullname,
  formatGender,
  formatOrganizationName,
}) {
  return (
    <>
      <OwnerFields
        owners={members
          ?.sort((a, b) => a.order - b.order)
          ?.filter((item) => item?.projectRole?.code?.toLowerCase().includes('owner'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatOrganizationName={formatOrganizationName}
      />
      <ScientificSecretaryFields
        scientificSecretaries={members
          ?.sort((a, b) => a.order - b.order)
          .filter((item) => item?.projectRole?.code?.toLowerCase().includes('secretary'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatOrganizationName={formatOrganizationName}
      />
      <MainParticipantFields
        mainParticipants={members
          ?.sort((a, b) => a.order - b.order)
          ?.filter((item) => item?.projectRole?.code?.toLowerCase().includes('main'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatOrganizationName={formatOrganizationName}
      />
      <ParticipantFields
        participants={members
          ?.sort((a, b) => a.order - b.order)
          .filter((item) => item?.projectRole?.code?.toLowerCase() === 'participant')}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatOrganizationName={formatOrganizationName}
      />
      <TechnicianFields
        technicians={members
          ?.sort((a, b) => a.order - b.order)
          ?.filter(
            (item) =>
              item?.projectRole?.code?.toLowerCase().includes('technician') ||
              item?.projectRole?.code?.toLowerCase().includes('support')
          )}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatOrganizationName={formatOrganizationName}
      />
      <DomesticExpertFields
        experts={members
          ?.sort((a, b) => a.order - b.order)
          ?.filter((item) => item?.projectRole?.code?.toLowerCase().includes('domestic'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatOrganizationName={formatOrganizationName}
      />
      <InternationalExpertFields
        experts={members
          ?.sort((a, b) => a.order - b.order)
          .filter((item) => item?.projectRole?.code?.toLowerCase().includes('international'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatOrganizationName={formatOrganizationName}
      />
    </>
  );
}

ViewHistoricalPersonnelAdjustmentItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  members: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  formatIndex: PropTypes.func.isRequired,
  formatFullname: PropTypes.func.isRequired,
  formatGender: PropTypes.func.isRequired,
  formatOrganizationName: PropTypes.func.isRequired,
};
